<template>
  <v-card>
    <v-toolbar
      color="primary"
      dark
    > {{ dialogContent.dialogLabel }}</v-toolbar>
      <v-card-text>
        <div class="text-h2 pa-8">
          <v-text-field v-model="dialogContent.value"
          class="pa-1" label="New Value" dense filled hide-details single-line ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
        text
        @click="$emit('close')"
        >Fermer</v-btn>
        <v-btn
        text
        @click="$emit('save', dialogContent.value)"
        >Enregistrer</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    dialogContent: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'save']
}
</script>